"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventArgs = /** @class */ (function () {
    function EventArgs(payload) {
        this.payload = payload;
    }
    return EventArgs;
}());
exports.default = EventArgs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/models/EventArgs.js
// module id = 1665
// module chunks = 8